<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lG4DbB/tc-custom/9781488020025.jpg?1726519015476" alt="This image is the cover for the book Call to Redemption, SEAL Brotherhood"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Call to Redemption, SEAL Brotherhood
      </h1>
      <p class="bookDescription body article font2">
        <b>The Poseidon team are hard-bodied, fiercely competitive Navy SEALs. But when a sensitive mission goes disastrously wrong, three of the team’s finest will have to trust their hearts and instincts to uncover the truth…</b><br/><br/>No strings. No questions. Just pleasure. For a few blissful days, Lieutenant Commander Nic Savino is enjoying a wild fling with the sexiest stranger he’s ever laid eyes—or any other body part—on. It’s almost enough to make the stalwart SEAL let down his guard for once. Until he learns that assistant US attorney Darby Raye—<i>his</i> Darby—is heading an investigation designed to destroy him…and Poseidon.<br/><br/>The gorgeous eyes that Darby spent her nights gazing into are now glaring at her across a courtroom. This case could build her career, but if Nic’s not a traitor, then he’s being framed by forces powerful enough to eliminate every obstacle in their way. And the tentative trust she and Nic are rebuilding—as well as their very lives—could become collateral damage…
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tawny Weber
      </h2>
      
      <p class="authorDescription body article">Tawny Weber is the New York Times and USA TODAY bestselling author of more than forty books. She writes sexy, emotional romances with a dash of humor and is known for her heroes, most notably her popular Navy SEALs series. The recipient of numerous writing awards, Tawny has also hit number one on the Amazon and Barnes & Noble bestseller lists.  She lives with her family in Northern California. Visit her at www.tawnyweber.com and look for her on Facebook, Twitter, Pinterest and Goodreads.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?305a4324